var _circle, _circle2, _polygon, _polygon2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8UseForklift50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 34,
    r: 3,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "29.968,13 25.968,13 26.968,9 28.968,9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "14.616,34.606 8.003,32.917 8.497,30.979 13.163,32.171 18.204,11.995 20.144,12.479"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 34.5,
    r: 2.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36,21h-5.741c-0.77,0-1.471,0.442-1.804,1.136L27.083,25H16.016l-1.998,8h3.084 c0.465-2.279,2.484-4,4.899-4s4.434,1.721,4.899,4h4.378c0.621-1.742,2.271-3,4.224-3c0.925,0,1.782,0.282,2.498,0.762V23 C37.998,21.895,37.105,21,36,21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.18,26l2.697-10.787C25.056,14.499,25.694,14,26.43,14H33v8h2v-8c0-1.103-0.897-2-2-2h-6.57 c-1.654,0-3.091,1.121-3.492,2.728L20.12,26H22.18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8UseForklift50);
export default __webpack_public_path__ + "static/media/icons8-use-forklift-50.c7f3c992202de6f1cf5b55d3928a2fca.svg";
export { ForwardRef as ReactComponent };